import { Component, Prop, h, Host } from '@stencil/core';

/**
 * @slot default - content for the tab panel. Will render when active index is equal to index
 */
@Component({
  tag: 'uui-tab-panel',
  styleUrl: 'uui-tab-panel.css',
  shadow: true
})
export class UuiTabPanel {
  /** index for the tab that this panel relates to */
  @Prop({ reflect: true }) index: number;
  @Prop({ reflect: true }) activeindex: number;

  render() {
    if(this.index !== this.activeindex) return null;
    return (
      <Host>
        <slot />
      </Host>
    );
  }
}
